var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Video_lockStatus, _Video_status, _Video_waitingId, _Video_handlers;
const VIDEO_PLAYBACK_DELAY_MS = 50;
const VIDEO_CLASS_NAME = 'prod-teaser__cover--video';
const VIDEO_SIZE = 180;
class Video {
    constructor(url, cover, posterUrl) {
        this.url = url;
        this.cover = cover;
        this.posterUrl = posterUrl;
        _Video_lockStatus.set(this, void 0);
        _Video_status.set(this, 'init');
        _Video_waitingId.set(this, void 0);
        _Video_handlers.set(this, {
            onerror: null,
            onload: null,
            onpause: null,
        });
        this.listeners = new Set();
    }
    get status() {
        return __classPrivateFieldGet(this, _Video_status, "f");
    }
    set status(status) {
        if (__classPrivateFieldGet(this, _Video_status, "f") === 'error' && status !== 'loading') {
            return;
        }
        if (status === 'waited' && __classPrivateFieldGet(this, _Video_status, "f") !== 'waiting') {
            return;
        }
        __classPrivateFieldSet(this, _Video_status, status, "f");
        for (const listener of this.listeners) {
            listener(this);
        }
    }
    get loaded() {
        return this.status !== 'loading' && this.status !== 'init' && this.status !== 'error';
    }
    get locked() {
        return __classPrivateFieldGet(this, _Video_status, "f") === 'locked';
    }
    get playing() {
        return this.video && this.video.currentTime && !this.video.paused && !this.video.ended;
    }
    show() {
        this.resetStatus();
    }
    hide() {
        this.stop();
        this.resetStatus();
    }
    preload() {
        if (this.status === 'loading' || this.loaded) {
            return;
        }
        this.remove();
        this.video = document.createElement('video');
        this.video.autoplay = true;
        this.video.muted = true;
        this.video.controls = false;
        this.video.playsInline = true;
        this.video.addEventListener('error', __classPrivateFieldGet(this, _Video_handlers, "f").onerror = this.onerror.bind(this));
        this.video.addEventListener('canplay', __classPrivateFieldGet(this, _Video_handlers, "f").onload = this.onload.bind(this));
        this.video.src = this.url;
        this.status = 'loading';
    }
    wait() {
        if (this.status !== 'ready') {
            return;
        }
        clearTimeout(__classPrivateFieldGet(this, _Video_waitingId, "f"));
        __classPrivateFieldSet(this, _Video_waitingId, setTimeout(() => this.status = 'waited', VIDEO_PLAYBACK_DELAY_MS), "f");
        this.status = 'waiting';
    }
    play() {
        if (this.status !== 'waited') {
            return false;
        }
        this.remove();
        this.video = document.createElement('video');
        this.video.width = VIDEO_SIZE;
        this.video.height = VIDEO_SIZE;
        this.video.autoplay = true;
        this.video.controls = false;
        this.video.poster = this.posterUrl;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.addEventListener('pause', __classPrivateFieldGet(this, _Video_handlers, "f").onpause = this.onpause.bind(this), { once: true });
        this.video.src = this.url;
        this.cover.append(this.video);
        this.cover.classList.add(VIDEO_CLASS_NAME);
        this.status = 'playing';
        return true;
    }
    lock() {
        if (this.locked) {
            return;
        }
        this.stop();
        if (this.status === 'done') {
            __classPrivateFieldSet(this, _Video_lockStatus, 'done', "f");
        }
        else {
            __classPrivateFieldSet(this, _Video_lockStatus, this.loaded ? 'ready' : 'init', "f");
        }
        this.status = 'locked';
    }
    unlock() {
        if (!this.locked) {
            return;
        }
        this.status = __classPrivateFieldGet(this, _Video_lockStatus, "f");
    }
    destroy() {
        this.remove();
    }
    addListener(listener) {
        this.listeners.add(listener);
    }
    removeListener(listener) {
        this.listeners.delete(listener);
    }
    stop() {
        if (!this.cover.classList.contains(VIDEO_CLASS_NAME)) {
            return;
        }
        this.cover.classList.remove(VIDEO_CLASS_NAME);
        this.remove();
    }
    onerror() {
        this.status = 'error';
    }
    onload() {
        this.status = 'ready';
    }
    onpause() {
        this.status = 'done';
    }
    resetStatus() {
        this.status = this.loaded ? 'ready' : 'init';
    }
    remove() {
        if (!this.video) {
            return;
        }
        this.video.remove();
        this.video.removeEventListener('error', __classPrivateFieldGet(this, _Video_handlers, "f").onerror);
        this.video.removeEventListener('canplaythrough', __classPrivateFieldGet(this, _Video_handlers, "f").onload);
        this.video.removeEventListener('pause', __classPrivateFieldGet(this, _Video_handlers, "f").onpause);
        this.video = null;
    }
}
_Video_lockStatus = new WeakMap(), _Video_status = new WeakMap(), _Video_waitingId = new WeakMap(), _Video_handlers = new WeakMap();
export default Video;
